var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconConversationDefaultAvatar = function SvgIconConversationDefaultAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_conversation_default_avatar_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_conversation_default_avatar_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M20.59 13.238s.995-4.114 0-5.508c-.997-1.392-1.393-2.32-3.583-2.985-2.19-.664-1.392-.532-2.985-.464-1.594.068-2.92.93-2.92 1.394 0 0-.996.066-1.392.465-.399.398-1.062 2.254-1.062 2.718s.332 3.586.663 4.248l-.395.134c-.332 3.847 1.325 4.312 1.325 4.312.597 3.584 1.195 2.058 1.195 2.986s-.598.598-.598.598-.53 1.459-1.856 1.99-8.69 3.382-9.29 3.98-.531 3.384-.531 3.384h31.578s.07-2.786-.53-3.384c-.597-.598-7.962-3.45-9.29-3.98-1.326-.531-1.855-1.99-1.855-1.99s-.598.33-.598-.598.598.598 1.195-2.986c0 0 1.656-.465 1.324-4.312h-.398z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_conversation_default_avatar_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgIconConversationDefaultAvatar;